
<a-select
  :options="options"
  v-model.sync="localValue"
  btn-color="clear-area"
  :has-teleport="!outsideModal"
  :missing-option-error-message="missingOptionErrorMessage"
>
</a-select>
